import { atom } from 'jotai';

import { atomFiles } from './Steps';

/**
 * @desc Atom of progress for first step of import contacts
 */
export const atomStep3ShowProgress = atom<boolean>(true);
atomStep3ShowProgress.debugLabel = 'atomStep3ShowProgress';

/**
 * @desc Atom of progress for first step of import contacts
 */
export const atomStep3ShowProgressDerived = atom(
  (get) => {
    const files = get(atomFiles);
    return files?.showProgressCard ?? get(atomStep3ShowProgress);
  },
  (get, set, newValue: boolean) => {
    set(atomStep3ShowProgress, newValue);
  }
);
atomStep3ShowProgressDerived.debugLabel = 'atomStep3ShowProgressDerived';
